import { jwtDecode } from 'jwt-decode';
import { CognitoUser } from '../types';

interface DecodedToken {
  sub: string;
  email: string;
  name: string;
  'cognito:groups'?: string[];
  'custom:role'?: string;
  email_verified: boolean;
  exp: number;
  iat: number;
}

export const decodeToken = (token: string): DecodedToken => {
  return jwtDecode<DecodedToken>(token);
};

export const isTokenExpired = (token: string): boolean => {
  try {
    const decoded = decodeToken(token);
    const currentTime = Date.now() / 1000;
    return decoded.exp < currentTime;
  } catch {
    return true;
  }
};

export const extractUserFromToken = (idToken: string): CognitoUser => {
  const decoded = decodeToken(idToken);
  
  return {
    username: decoded.sub,
    email: decoded.email,
    name: decoded.name,
    role: decoded['custom:role'],
    groups: decoded['cognito:groups'] || [],
    email_verified: decoded.email_verified,
    sub: decoded.sub,
  };
};

export const getTokenExpiry = (token: string): Date | null => {
  try {
    const decoded = decodeToken(token);
    return new Date(decoded.exp * 1000);
  } catch {
    return null;
  }
};